import { FormLabel } from '@/components/ui/form-label';
import { Switch } from '@/components/ui/switch';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, AlertCircle, Lock } from 'lucide-react';
import { FormFieldWrapper } from '@/components/ui/form-field-wrapper';
interface TransactionStatusFieldProps {
  status: 'paid' | 'pending';
  onStatusChange: (status: 'paid' | 'pending') => void;
  disabled?: boolean;
  paymentMethod?: string;
  transactionType?: string;
  compact?: boolean;
  transactionDate?: string;
}
export const TransactionStatusField = ({
  status,
  onStatusChange,
  disabled = false,
  paymentMethod,
  transactionType,
  compact = false,
  transactionDate
}: TransactionStatusFieldProps) => {
  const isPaid = status === 'paid';

  // Check if transaction date is in the future
  const isFutureTransaction = transactionDate && transactionDate > new Date().toISOString().split('T')[0];

  // Credit card expenses are always pending until bill is paid
  const isCreditCardExpense = paymentMethod === 'cartao' && transactionType === 'despesa';
  const isStatusLocked = isCreditCardExpense || isFutureTransaction;

  // Force pending status for credit card expenses or future transactions
  const actualStatus = isCreditCardExpense || isFutureTransaction ? 'pending' : status;
  const actualIsPaid = actualStatus === 'paid';
  if (compact) {
    return <div className="flex items-center gap-2">
        <Switch checked={actualIsPaid} onCheckedChange={checked => {
        onStatusChange(checked ? 'paid' : 'pending');
      }} disabled={disabled || isStatusLocked} className="data-[state=checked]:bg-green-600" />
        <div className="flex items-center gap-1.5">
          {actualIsPaid ? <CheckCircle className="h-4 w-4 text-green-600" /> : <AlertCircle className="h-4 w-4 text-orange-500" />}
          <span className={`text-sm font-medium ${actualIsPaid ? 'text-green-600' : 'text-orange-500'}`}>
            {actualIsPaid ? 'Pago' : 'Pendente'}
          </span>
        </div>
      </div>;
  }
  return <Card className="rounded-xl">
      <CardContent className="p-5">
        <div className="">
          <FormLabel className="text-sm">Status do Pagamento</FormLabel>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              {/* Show switch only for non-credit card expenses and non-future transactions */}
              {!isCreditCardExpense && !isFutureTransaction && <Switch checked={actualIsPaid} onCheckedChange={checked => {
              onStatusChange(checked ? 'paid' : 'pending');
            }} disabled={disabled} className="data-[state=checked]:bg-green-600 scale-90" />}
              
              <div className="flex items-center gap-1.5">
                {isStatusLocked && <Lock className="h-3 w-3 text-muted-foreground" />}
                {actualIsPaid ? <CheckCircle className="h-4 w-4 text-green-600" /> : <AlertCircle className="h-4 w-4 text-orange-500" />}
                <span className={`text-sm font-medium ${actualIsPaid ? 'text-green-600' : 'text-orange-500'}`}>
                  {actualIsPaid ? 'Pago' : 'Pendente'}
                </span>
              </div>
            </div>
          </div>
          
          <p className="text-xs text-muted-foreground">
            {isFutureTransaction ? 'Transações com data futura são criadas inicialmente como pendentes' : isCreditCardExpense ? 'Transações de cartão são pendentes até o pagamento da fatura' : actualIsPaid ? 'Esta transação foi marcada como paga' : 'Esta transação está pendente de pagamento'}
          </p>
        </div>
      </CardContent>
    </Card>;
};